// extracted by mini-css-extract-plugin
module.exports = {"MuiFormControlRoot":"UserRoleSelect_MuiFormControlRoot__3xg7_"};